import { createQueryHook } from '../../createQueryHook'

export default createQueryHook<{ page: number, pageSize: number, search: string}, any>({
  getKey: ({ page, pageSize, search }) => [`afe0bea8-1a3d-44ba-ab4d-4254b839b115/Get?page=${page}&pageSize=${pageSize}&search=${search}`],
  getEndpoint: ({ page, pageSize, search }) => `afe0bea8-1a3d-44ba-ab4d-4254b839b115/Get?page=${page}&pageSize=${pageSize}&search=${search}`
})
